// extracted by mini-css-extract-plugin
var _1 = "tooltip_background__22kdy";
var _2 = "#4c4c4c";
var _3 = "tooltip_content__hkn5w";
var _4 = "tooltip_contentwrapper__4lfjw";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "#434343";
var _9 = "tooltip_hidden__bnxoc";
var _a = "tooltip_infopopover__v+geu";
var _b = "79px";
var _c = "110px";
var _d = "72px";
var _e = "665px";
var _f = "tooltip_spacer__ptxra";
var _10 = "teal";
var _11 = "2";
var _12 = "#cdd3dc";
var _13 = "tooltip_tooltip__tiirw";
var _14 = "tooltip_visible__ei2f4";
var _15 = "tooltip_wrapper__bpzjm";
export { _1 as "background", _2 as "body", _3 as "content", _4 as "contentWrapper", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "headline", _9 as "hidden", _a as "infoPopover", _b as "menuHeight", _c as "menuHeightLarge", _d as "menuHeightMobile", _e as "modalMobileWidth", _f as "spacer", _10 as "teal", _11 as "timelineStrokeWidth", _12 as "timelineTrackColor", _13 as "tooltip", _14 as "visible", _15 as "wrapper" }
